define("shared/components/shared/date-time-picker", ["exports", "@ember/component", "@ember/object/computed", "@ember/service", "@glimmer/component", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _computed, _service, _component2, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/component",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::BaseTimePicker
    @config={{this.rawFlatpickrConfig}}
    @disabled={{@disabled}}
    @inputClass={{@inputClass}}
    @pickerClass={{@pickerClass}}
    @pickerContainerId={{@pickerContainerId}}
    @pickerId={{@pickerId}}
    @placeholder={{@placeholder}}
    @setFlatpickrReference={{@setFlatpickrReference}}
  >
  
    <:beforeInput as |pickerId|>
      {{#if @showScheduleIcon}}
        <label class="o--btn o--btn--outline" for={{pickerId}}>
          {{svg-jar "schedule" class="o--icon o--icon--hl"}}
        </label>
      {{/if}}
    </:beforeInput>
  
    <:afterInput>
      {{#if @showCaretIcon}}
        <span>
          {{svg-jar "caret-down" class="o--icon"}}
        </span>
      {{/if}}
    </:afterInput>
  
  </Shared::BaseTimePicker>
  */
  {
    "id": "OSuY1MKu",
    "block": "[[[8,[39,0],null,[[\"@config\",\"@disabled\",\"@inputClass\",\"@pickerClass\",\"@pickerContainerId\",\"@pickerId\",\"@placeholder\",\"@setFlatpickrReference\"],[[30,0,[\"rawFlatpickrConfig\"]],[30,1],[30,2],[30,3],[30,4],[30,5],[30,6],[30,7]]],[[\"beforeInput\",\"afterInput\"],[[[[1,\"\\n\"],[41,[30,9],[[[1,\"      \"],[10,\"label\"],[14,0,\"o--btn o--btn--outline\"],[15,\"for\",[30,8]],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"schedule\"],[[\"class\"],[\"o--icon o--icon--hl\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[8]],[[[1,\"\\n\"],[41,[30,10],[[[1,\"      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"caret-down\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@disabled\",\"@inputClass\",\"@pickerClass\",\"@pickerContainerId\",\"@pickerId\",\"@placeholder\",\"@setFlatpickrReference\",\"pickerId\",\"@showScheduleIcon\",\"@showCaretIcon\"],false,[\"shared/base-time-picker\",\"if\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/date-time-picker.hbs",
    "isStrictMode": false
  });

  /**
   * @class Shared::DateTimePicker
   * @extends Component
   *
   * This component makes use of Shared::BaseTimePicker to provide a configurable single timepicker.
   *
   * Arguments:
   * - [inputClass] (String) Class to be appended to the input element
   * - [showCaretIcon] (Boolean) Whether or not a dropdown caret icon is displayed
   * - [showScheduleIcon] (Boolean) Whether or not a schedule icon is displayed
   * - [disabled] (Boolean) Whether or not the time picker is disabled
   * - [onDateChange] (action) Function to trigger on every date selection
   * - [onDateChangeOptions] (any) Optional additional parameters for the onDateChange function
   *
   * - [dateTime] (Number) Unix timestamp used to set the initial selected date Default: current time
   * - [defaultDate] (String) Date string in one of the recognized formats (ignored if dateTime is set)
   * - [minDate] (String/Date) The minimum date that a user can start picking from  Default: current time
   *
   * This component can also accept any additional config options as found in: https://flatpickr.js.org/options/
   *
   */
  let DateTimePickerComponent = _exports.default = (_dec = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), (_class = class DateTimePickerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _initializerDefineProperty(this, "timezoneIdentifier", _descriptor2, this);
      _defineProperty(this, "onValueUpdate", selectedDates => {
        // always assume that the date is local to userConfig.currentTimeZone
        const selectedDate = moment(selectedDates[0]).tz(this.timezoneIdentifier, true);
        const timestamp = selectedDate.unix();
        if (typeof this.args.onDateChange === 'function') {
          this.args.onDateChange(selectedDates, timestamp, this.args.onDateChangeOptions);
        }
      });
    }
    get flatpickrDefaults() {
      return {
        altInput: true,
        // Note: Allow defaultDate to be before minDate if scheduled time has passed.
        allowInvalidPreload: this.args.dateTime < (0, _timeFormat.timestamp)(),
        allowInput: true,
        clickOpens: false,
        wrap: true,
        minDate: this.timezoneIdentifier ? moment().tz(this.timezoneIdentifier).format('YYYY-MM-DD HH:mm') : moment().format('YYYY-MM-DD HH:mm')
      };
    }
    get rawFlatpickrConfig() {
      const {
        dateTime,
        dateFormat = 'Y-m-dTG:i:S',
        defaultDate,
        onDateChange,
        ...rest
      } = this.args;
      return {
        ...this.flatpickrDefaults,
        dateFormat,
        defaultDate,
        onDateChange,
        onValueUpdate: this.onValueUpdate,
        dateTime,
        ...rest
      };
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "timezoneIdentifier", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DateTimePickerComponent);
});